import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { Col, Button } from 'react-bootstrap';
import browserHistory from '../history';
import PageContainer from './PageContainer';
import Header from './Header';
import Footer from './Footer';
import PanelWidget from './widget/PanelWidget';
// import VendorWidget from './widget/VendorWidget';

const arList = [
  { label: 'Post Receipts', url: '/APA1' },
  { label: 'Post Cash Receipts', url: '/APA1C' },
  { label: 'Post Bank Deposits', url: '/APA1D' },
  { label: 'General Journal Entires', url: '/APA6' },
  { label: 'Create Miscellaneous Invoice', url: '/AAR14' },
  { label: 'Post Offset/Write Down to Clear Open Items', url: 'AAR15' },
];

const apList = [
  { label: 'Post Manually', url: '/APT1' },
  { label: 'Post Automatic Vouchers', url: '/APT2' },
  { label: 'Update Automatic Vouchers', url: '/APT3' },
  { label: 'Print Automatic Vouchers', url: '/APT4' },
  { label: 'Process Invoices From Receipts', url: '/APT5' },
  { label: "Receive Expense Po's", url: '/APT6' },
  { label: 'Post Reversing Entries', url: '/APT7' },
  { label: 'Change Due Dates', url: '/APT8' },
  { label: 'Pay Invoices With Credit Card', url: '/APT9' },
  { label: 'Import Postings Using Csv File ', url: '/APT10' },
  { label: 'Inquire Balance Detail', url: '/AAP4' },
];

const reports = [
  { label: 'Inquiry', url: '/ACU2' },
  { label: 'Affliated Customers', url: '/ACU3' },
  { label: 'Tax Certificate Expiration', url: '/ACU5' },
  { label: 'Customer Tax Locales', url: '/ACU6' },
  { label: 'Customer Name and Address Reports', url: '/AAR6A' },
];

const WidgetList = links => {
  return (
    <>
      {links.map(page => {
        return (
          <Link className="dashboard-link" key={page.label} to={page.url}>
            {page.label}
          </Link>
        );
      })}
    </>
  );
};

class Accounting extends PureComponent {
  nav(route) {
    browserHistory.push(route);
  }

  render() {
    return (
      <PageContainer className="accounting-dashboard">
        <Header title="Accounting" showInfo={false} />
        {/* <div className="primary-toolbar">
          <DropdownButton id="Create" title="Create" variant="success">
            <Dropdown.Item href="/list/ACU1/new">Customer</Dropdown.Item>
            <Dropdown.Item href="/list/AAP13/new">Vendor</Dropdown.Item>
          </DropdownButton>
        </div> */}
        <div id="dashboard">
          <div className="create-wrapper">
            <div className="crud-item-wrapper">
              <div
                className="panel flex-panel crud-item list-item"
                onClick={() => {
                  this.nav('/list/AAP13');
                }}
              >
                <i className="zmdi zmdi-store" />
                Vendors
              </div>
            </div>
            <div className="crud-item-wrapper">
              <div
                className="panel flex-panel crud-item list-item"
                onClick={() => {
                  this.nav('/list/ACU1');
                }}
              >
                <i className="zmdi zmdi-accounts" />
                Customers
              </div>
            </div>
            <div className="crud-item-wrapper">
              <div
                className="panel flex-panel crud-item list-item"
                onClick={() => {
                  this.nav('/list/APO1');
                }}
              >
                <i className="zmdi zmdi-money" />
                Purchase Orders
              </div>
            </div>
            <div className="crud-item-wrapper">
              <div
                className="panel flex-panel crud-item list-item"
                onClick={() => {
                  this.nav('/list/AVI3');
                }}
              >
                <i className="zmdi zmdi-car" />
                Vehicles
              </div>
            </div>
            <div className="crud-item-wrapper right-side">
              <div
                className="panel flex-panel crud-item new-item"
                onClick={() => {
                  this.nav('/list/AVI3');
                }}
              >
                <i className="zmdi zmdi-plus-circle" />
                Create
              </div>
            </div>
            <div className="clearfix" />
          </div>
          {/* <div className="amounts">
            <Col sm={6} md={6} lg={6}>
              <div className="receive">
                $1753.94
              </div>
            </Col>
            <Col sm={6} md={6} lg={6}>
              <div className="pay">
                $1304.20
              </div>
            </Col>
            <div className="clearfix" />
          </div> */}
          <div className="widgets">
            <Col sm={6} md={6} lg={4}>
              <PanelWidget header="Accounts Receivable">{WidgetList(arList)}</PanelWidget>
            </Col>
            <Col sm={6} md={6} lg={4}>
              <PanelWidget header="Accounts Payable">{WidgetList(apList)}</PanelWidget>
            </Col>
            <Col sm={6} md={6} lg={4}>
              <PanelWidget header="Reports">{WidgetList(reports)}</PanelWidget>
            </Col>
            {/* <Col sm={6} md={6} lg={4}>
              <PanelWidget header="Vendor" className="fitted">
                <VendorWidget />
              </PanelWidget>
            </Col> */}
            <div className="clearfix" />
            <div className="index-button">
              <Button
                onClick={() => {
                  this.nav('/menu/Accounting');
                }}
                variant="secondary"
              >
                Accounting Index
              </Button>
            </div>
          </div>
        </div>
        <Footer />
      </PageContainer>
    );
  }
}

export default Accounting;
